import { useQuery, useMutation } from '@tanstack/react-query';
import { getUserSubcription, createSubscriptionRequest } from '../services/subscription.service';
import { subscriptionKeys } from './keys/subscription';

export const useUserSubscription = () => {
    return useQuery({
        queryKey: [subscriptionKeys.userSubscription],
        queryFn: getUserSubcription,
    });
};

export const useUserSubscriptionRequest = ({onSuccess, onError}) => {
    return useMutation({
        mutationFn: createSubscriptionRequest,
        onSuccess: (data) => {
            onSuccess(data);
        },
        onError: (error) => {
            onError(error);
        },
      });
}